var _linearGradient, _path, _path2, _linearGradient2, _path3, _linearGradient3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPpsx(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 36,
    y1: 95.3,
    x2: 36,
    y2: -3.2,
    gradientTransform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cb5528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.032,
    stopColor: "#cf5b27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.162,
    stopColor: "#db7026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#e68025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#ee8c23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#f49322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f69622"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 .8l27 26.9v71.6H0V.8h45z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 .8l27 26.9v71.6H0V.8h45z",
    fillOpacity: 0,
    stroke: "#c15127",
    strokeWidth: 2
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 12.838,
    y1: 54.262,
    x2: 49.833,
    y2: 17.267,
    gradientTransform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#d65b25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#d35a25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#ca5624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.897,
    stopColor: "#bc4f22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b34b21"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 32c0 2.3-.5 4.4-1.4 6-1 1.7-2.3 3.1-4 4.1-1.8 1.1-3.8 1.9-6 2.4-2.3.5-4.8.7-7.6.7H34v11.6c0 .7.1 1.3.4 1.8s.8.9 1.5 1.2c.4.2 1 .3 1.9.5s1.6.3 2.2.4V63H17.5v-2.3c.6-.1 1.3-.1 2.3-.2.9-.1 1.6-.2 2-.4.8-.3 1.3-.7 1.5-1.1s.4-1.1.4-1.9V27.9c0-.7-.1-1.3-.4-1.8-.2-.5-.7-.9-1.5-1.2-.5-.2-1.3-.4-2.2-.6-.9-.2-1.6-.3-2-.4v-2.3h22.9c5.4 0 9.4.9 12 2.6 2.6 1.7 4 4.3 4 7.8zM45 33.5c0-3.1-.6-5.4-1.9-7-1.3-1.5-3.5-2.3-6.7-2.3H34v18.1h1.2c3.2 0 5.6-.7 7.3-2.2 1.7-1.3 2.5-3.5 2.5-6.6z",
    fill: "url(#b)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 45.07,
    y1: 23.68,
    x2: 58.57,
    y2: 10.18,
    gradientTransform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffce3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#fffae0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#fdf3d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#fbebcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#f8dfbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767,
    stopColor: "#f5d0a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#f1bf8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#ecaa72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#e79354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#e27c34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#df6f26"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 .8l27 26.9H45V.8z",
    fill: "url(#c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 .8l27 26.9H45V.8z",
    fillOpacity: 0,
    stroke: "#c15127",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6 91.3V75.6h5.1c1.9 0 3.2.1 3.8.2.9.2 1.7.8 2.3 1.5.6.8.9 1.8.9 3.1 0 1-.2 1.8-.5 2.4-.4.7-.8 1.2-1.3 1.6-.5.4-1.1.6-1.7.7-.8.2-1.9.2-3.3.2h-2.1v5.9H7.6zm3.2-13.1v4.5h1.8c1.3 0 2.1-.1 2.5-.2.4-.2.8-.4 1-.8.2-.4.4-.8.4-1.2 0-.6-.2-1-.5-1.4-.3-.4-.8-.6-1.3-.7-.4-.1-1.1-.1-2.3-.1h-1.6zm11.6 13.1V75.6h5.1c1.9 0 3.2.1 3.8.2.9.2 1.7.8 2.3 1.5.6.8.9 1.8.9 3.1 0 1-.2 1.8-.5 2.4-.4.7-.8 1.2-1.3 1.6-.5.4-1.1.6-1.7.7-.8.2-1.9.2-3.3.2h-2.1v5.9h-3.2zm3.2-13.1v4.5h1.8c1.3 0 2.1-.1 2.5-.2.4-.2.8-.4 1-.8.2-.4.4-.8.4-1.2 0-.6-.2-1-.5-1.4-.3-.4-.8-.6-1.3-.7-.4-.1-1.1-.1-2.3-.1h-1.6zm10.8 8l3.1-.3c.2 1 .6 1.8 1.1 2.3.6.5 1.3.7 2.3.7 1 0 1.8-.2 2.3-.7.5-.4.8-.9.8-1.5 0-.4-.1-.7-.3-1-.2-.3-.6-.5-1.2-.7-.4-.1-1.2-.4-2.6-.7-1.7-.4-2.9-.9-3.6-1.6-1-.9-1.5-1.9-1.5-3.2 0-.8.2-1.6.7-2.2.5-.7 1.1-1.2 2-1.6.9-.4 1.9-.5 3.1-.5 2 0 3.5.4 4.5 1.3s1.5 2 1.6 3.5l-3.2.1c-.1-.8-.4-1.4-.9-1.7-.5-.4-1.1-.5-2-.5-.9 0-1.7.2-2.2.6-.3.2-.5.6-.5 1s.2.7.5 1c.4.3 1.4.7 2.9 1.1 1.6.4 2.7.7 3.5 1.1.7.4 1.3.9 1.8 1.6.4.7.6 1.5.6 2.5 0 .9-.3 1.7-.8 2.5-.4.7-1.1 1.3-2 1.7-.9.4-2.1.6-3.4.6-2 0-3.5-.5-4.6-1.4-1.2-.9-1.8-2.3-2-4zm13.9 5.1l5.4-8.2-4.9-7.5h3.7l3.2 5.1 3.1-5.1h3.7l-4.9 7.6 5.4 8.1h-3.9l-3.5-5.4-3.5 5.4h-3.8z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpsx);
export default __webpack_public_path__ + "static/media/ppsx.aaa33217a93172cb0c6b285282f92aa2.svg";
export { ForwardRef as ReactComponent };